import assets from "../../assets";
import "./style.sass";
import { useHandler } from "./handler";
import { DescriptiveHero } from "../descriptive-hero";
import { QuestionSection } from "../question-section";
import {
  QUESTION_WEIGHTAGE_CBSE,
  QUESTION_WEIGHTAGE_STATE_BOARD,
  LANGUAGE_OPTIONS,
} from "../../utils/constant";

const QuizDropdown = ({
  label,
  refKey,
  dropKey,
  value,
  options,
  onSelect,
  placeholder,
  prerequisite,
  prerequisiteLabel,
  setOpenDropdown,
  openDropdown,
  isLoading,
}) => (
  <section
    className="subject_wrapper"
    ref={refKey}
    onClick={() => setOpenDropdown(dropKey)}
  >
    <h4>{label}</h4>
    <section className="drop_down_wrapper">
      <p>{value || placeholder}</p>
      <img src={assets.ic_chevron_down} alt="chevron" />
    </section>
    {openDropdown === dropKey && (
      <section className="options_list">
        {prerequisite !== undefined && !prerequisite ? (
          <p
            style={{
              textAlign: "center",
              marginTop: "35%",
              color: "#22c55e",
            }}
          >
            Please select {prerequisiteLabel} first
          </p>
        ) : isLoading ? (
          <p
            style={{
              textAlign: "center",
              marginTop: "35%",
              color: "#22c55e",
            }}
          >
            Loading {label.toLowerCase()}...
          </p>
        ) : options?.length > 0 ? (
          options.map((item, i) => (
            <p
              key={i}
              className="option_item"
              onClick={(e) => {
                e.stopPropagation();
                onSelect(item);
                setOpenDropdown(null);
              }}
            >
              {item}
            </p>
          ))
        ) : (
          <p
            style={{
              textAlign: "center",
              marginTop: "35%",
              color: "#ef4444",
            }}
          >
            No {label.toLowerCase()} found
          </p>
        )}
      </section>
    )}
  </section>
);

export const Descriptive = () => {
  const {
    user,
    openDropdown,
    selectedSubject,
    subjects,
    isStartEnabled,
    isLoading,
    mediums,
    selectedMedium,
    questionPayload,
    setOpenDropdown,
    setSelectedSubject,
    onStartQuiz,
    setIsQuizActive,
    isQuizActive,
    setSelectedMedium,
    dropdownWrapperRef,
    questions,
    yearRef,
    selectedYear,
    years,
    selectedExam,
    handleUpscSubmit,
    mediumRef,
    setSelectedYear,
    questionType,
    questionDistribution,
    setQuestionDistribution,
    selectedTopic,
    setSelectedTopics,
    setSelectedMarks,
    selectedTopics,
    topics,
    marks,
    selectedMarks,
  } = useHandler();

  const handleResetAll = () => {
    setSelectedSubject("");
    setSelectedTopics([]);
    setSelectedMarks("");
    setQuestionDistribution({});
    setIsQuizActive(false);
  };

  return (
    <section className="desc_layout">
      <section className="desc_nav_context_contanier">
        <section className="desc_nav_learn_title">
          <h4>Descriptive Test</h4>
          <h6>Configure test details and generate questions</h6>
        </section>

        <section className="desc_nav_subject_details">
          <section className="desc_board_wrapper">
            <section className="desc_class">
              <h5>Competitive Exam</h5>
              <h4>{user?.data?.class}</h4>
            </section>
          </section>
        </section>

        <section className="quiz_default_medium_wrapper">
          <h4>Medium</h4>
          <h5>{user?.data?.medium}</h5>
        </section>

        <section className="desc_nav_subject_wrapper" ref={dropdownWrapperRef}>
          <QuizDropdown
            label="Year"
            refKey={yearRef}
            dropKey="year"
            value={selectedYear}
            options={years}
            onSelect={setSelectedYear}
            placeholder="Select Year"
            prerequisite={!!selectedExam}
            prerequisiteLabel="Exam"
            setOpenDropdown={setOpenDropdown}
            openDropdown={openDropdown}
            isLoading={isLoading}
          />
          <QuizDropdown
            label="Medium"
            refKey={mediumRef}
            dropKey="medium"
            value={selectedMedium}
            options={mediums}
            onSelect={setSelectedMedium}
            placeholder="Select Medium"
            prerequisite={!!selectedExam && !!selectedYear}
            prerequisiteLabel="Exam & Year"
            setOpenDropdown={setOpenDropdown}
            openDropdown={openDropdown}
            isLoading={isLoading}
          />
          <section
            className="desc_subject_wrapper"
            onClick={() => setOpenDropdown("subject")}
          >
            <h4>Subject</h4>
            <section className="desc_drop_down_wrapper">
              <p>{selectedSubject || "Select Subject"}</p>
              <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
            </section>
            {openDropdown === "subject" && (
              <section className="desc_options_list">
                {isLoading ? (
                  <p className="dropdown-message">Loading subjects...</p>
                ) : subjects?.length > 0 ? (
                  subjects?.map((item, i) => (
                    <p
                      key={i}
                      className="desc_option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedSubject(item);
                        setOpenDropdown(null);
                      }}
                    >
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="dropdown-message red">No subjects found</p>
                )}
              </section>
            )}
          </section>

          <section
            className="desc_subject_wrapper"
            onClick={() => setOpenDropdown("questionDistribution")}
          >
            <h4>Question Distribution</h4>

            <section className="desc_drop_down_wrapper">
              <section className="desc_selected_chapter_list">
                {Object.keys(questionDistribution).length === 0 ? (
                  <p>Select Question Distribution</p>
                ) : (
                  Object.entries(questionDistribution).map(([type, count]) => (
                    <section key={type} className="desc_items">
                      <p>
                        {type} ({count})
                      </p>

                      <img
                        src={assets.ic_close_white}
                        alt=""
                        onClick={(e) => {
                          e.stopPropagation();

                          setQuestionDistribution((prev) => {
                            const updated = { ...prev };
                            delete updated[type];
                            return updated;
                          });
                        }}
                      />
                    </section>
                  ))
                )}
              </section>

              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "questionDistribution" && (
              <section className="desc_options_list">
                {isLoading ? (
                  <p className="dropdown-message">Loading question types...</p>
                ) : questionType?.length > 0 ? (
                  questionType.map((type) => (
                    <section key={type} className="distribution_input_wrapper">
                      <label>{type}</label>

                      <input
                        type="number"
                        min="0"
                        placeholder="Enter count"
                        value={questionDistribution[type] || ""}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) =>
                          setQuestionDistribution((prev) => ({
                            ...prev,
                            [type]: Number(e.target.value),
                          }))
                        }
                      />
                    </section>
                  ))
                ) : (
                  <p className="dropdown-message red">
                    No question types found
                  </p>
                )}
              </section>
            )}
          </section>
          <QuizDropdown
            label="Marks"
            dropKey="marks"
            value={selectedMarks}
            options={marks}
            onSelect={setSelectedMarks}
            placeholder="Select Marks"
            prerequisite={Object.keys(questionDistribution).length > 0}
            prerequisiteLabel="Question Type"
            setOpenDropdown={setOpenDropdown}
            openDropdown={openDropdown}
            isLoading={isLoading}
          />
          <section
            className="desc_subject_wrapper"
            onClick={() => setOpenDropdown("topics")}
          >
            <h4>Topics</h4>

            <section className="desc_drop_down_wrapper">
              <section className="desc_selected_chapter_list">
                {selectedTopics.length === 0 ? (
                  <p>Select Topics</p>
                ) : (
                  selectedTopics.map((item) => (
                    <section key={item} className="desc_items">
                      <p>{item}</p>

                      <img
                        src={assets.ic_close_white}
                        alt=""
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedTopics((prev) =>
                            prev.filter((t) => t !== item),
                          );
                        }}
                      />
                    </section>
                  ))
                )}
              </section>

              <img src={assets.ic_chevron_down} alt="" />
            </section>

            {openDropdown === "topics" && (
              <section className="desc_options_list">
                {!selectedSubject ? (
                  <p className="dropdown-message">
                    Please select Subject first
                  </p>
                ) : (
                  topics?.map((item) => (
                    <p
                      key={item}
                      className={`desc_option_item ${
                        selectedTopics.includes(item) ? "selected" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();

                        setSelectedTopics((prev) =>
                          prev.includes(item)
                            ? prev.filter((x) => x !== item)
                            : [...prev, item],
                        );
                      }}
                    >
                      {item}
                      {selectedTopics.includes(item) && " ✓"}
                    </p>
                  ))
                )}
              </section>
            )}
          </section>
          <button
            className="desc_start_quiz_wrapper"
            disabled={!isStartEnabled}
            onClick={async () => {
              await onStartQuiz();
              setIsQuizActive(true);
            }}
          >
            {/* Generate Questions*/}
            <img src={assets.ic_quest} alt="quest generate" />
            Generate Questions
          </button>
        </section>
      </section>
      <section className="desc_wrapper">
        {isQuizActive ? (
          <QuestionSection
            questions={questions}
            onReset={handleResetAll}
            onSubmitAnswerSheet={handleUpscSubmit}
            questionPayload={questionPayload}
          />
        ) : (
          <DescriptiveHero />
        )}
      </section>
    </section>
  );
};
